<template>
<div class="chapter">
<div class="inner_page">
<p class="P_Basic-Paragraph_para-style-override-7__And__Centre_Alignment"><span> </span></p>
<p class="P_Basic-Paragraph_para-style-override-7__And__Centre_Alignment"><span><span style=" font-size: 2.17em;">The Haunting</span></span></p>
<p class="P_Basic-Paragraph_para-style-override-7__And__Centre_Alignment"><span><span style=" font-size: 2.17em;">of Cape Cod</span></span></p>
<p class="P_Basic-Paragraph_para-style-override-7__And__Centre_Alignment"><span><span style=" font-size: 2.17em;">and the Islands</span></span></p>
<p class="P_Basic-Paragraph_para-style-override-7__And__Centre_Alignment"><span> </span></p>
<p class="P_Basic-Paragraph_para-style-override-7__And__Centre_Alignment"><span><span style=" font-size: 1.58em;">Barbara Sillery</span></span></p>
<p class="P_div_frame-2"><span> </span></p>
<p class="P_div_frame-2"><span> </span></p>
<p class="P_div_frame-2"><span> </span></p>
<p class="P_div_frame-2"><span> </span></p>
<p class="P_div_frame-2"><span><img alt="PELOGO.TIF" class="frame-3" id="PELOGO_fmt" src="PELOGO_fmt.jpg" style=" max-width: 100%; max-height: 100%;"/></span></p>
<p class="P_x-0-Basic-paragraph-NO-INDENT_para-style-override-10__And__Centre_Alignment"><span><span style=" font-size: 1.17em;">PELICAN PUBLISHING COMPANY</span></span></p>
<p class="P_x-0-Basic-paragraph-NO-INDENT_para-style-override-7__And__Centre_Alignment"><span><span style=" font-style: normal; font-size: 1.17em;">Gretna</span><span style=" font-style: normal; font-size: 1.17em;"> 2014</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0002.vue?51cd5580